require("core-js/modules/esnext.global-this.js");

/**
 * @welldone-software/why-did-you-render 4.3.2
 * MIT Licensed
 * Generated by Vitali Zaidman <vzaidman@gmail.com> (https://github.com/vzaidman)
 * Generated at 2020-09-20
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("lodash/get"), require("lodash/isString"), require("lodash/reduce"), require("lodash/has"), require("lodash/keys"), require("lodash/isSet"), require("lodash/isFunction"), require("lodash/isRegExp"), require("lodash/isDate"), require("lodash/isPlainObject"), require("lodash/isArray"), require("lodash/defaults")) : "function" == typeof define && define.amd ? define(["lodash/get", "lodash/isString", "lodash/reduce", "lodash/has", "lodash/keys", "lodash/isSet", "lodash/isFunction", "lodash/isRegExp", "lodash/isDate", "lodash/isPlainObject", "lodash/isArray", "lodash/defaults"], t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).whyDidYouRender = t(e.lodash.get, e.lodash.isString, e.lodash.reduce, e.lodash.has, e.lodash.keys, e.lodash.isSet, e.lodash.isFunction, e.lodash.isRegExp, e.lodash.isDate, e.lodash.isPlainObject, e.lodash.isArray, e.lodash.defaults);
}(this, function (e, t, r, n, o, a, i, s, c, u, f, l) {
  "use strict";

  function p(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var d = p(e),
      h = p(t),
      y = p(r),
      m = p(n),
      v = p(o),
      g = p(a),
      b = p(i),
      D = p(s),
      w = p(c),
      O = p(u),
      _ = p(f),
      R = p(l);

  function k(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function E(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function S(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function N(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? S(Object(r), !0).forEach(function (t) {
        E(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function j(e) {
    return (j = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function x(e, t) {
    return (x = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function C(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function T(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? C(e) : t;
  }

  function P(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var r,
          n = j(e);

      if (t) {
        var o = j(this).constructor;
        r = Reflect.construct(n, arguments, o);
      } else r = n.apply(this, arguments);

      return T(this, r);
    };
  }

  function Y(e, t, r) {
    return (Y = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, r) {
      var n = function (e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = j(e));) {
          ;
        }

        return e;
      }(e, t);

      if (n) {
        var o = Object.getOwnPropertyDescriptor(n, t);
        return o.get ? o.get.call(r) : o.value;
      }
    })(e, t, r || e);
  }

  function H(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, s = e[Symbol.iterator](); !(n = (i = s.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          n || null == s.return || s.return();
        } finally {
          if (o) throw a;
        }
      }

      return r;
    }(e, t) || I(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function A(e) {
    return function (e) {
      if (Array.isArray(e)) return L(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || I(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function I(e, t) {
    if (e) {
      if ("string" == typeof e) return L(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? L(e, t) : void 0;
    }
  }

  function L(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  function M(e, t) {
    var r;

    if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
      if (Array.isArray(e) || (r = I(e)) || t && e && "number" == typeof e.length) {
        r && (e = r);

        var _n = 0,
            o = function o() {};

        return {
          s: o,
          n: function n() {
            return _n >= e.length ? {
              done: !0
            } : {
              done: !1,
              value: e[_n++]
            };
          },
          e: function e(_e2) {
            throw _e2;
          },
          f: o
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var a,
        i = !0,
        s = !1;
    return {
      s: function s() {
        r = e[Symbol.iterator]();
      },
      n: function n() {
        var e = r.next();
        return i = e.done, e;
      },
      e: function e(_e3) {
        s = !0, a = _e3;
      },
      f: function f() {
        try {
          i || null == r.return || r.return();
        } finally {
          if (s) throw a;
        }
      }
    };
  }

  var W,
      F = "different",
      q = "deepEquals",
      U = "date",
      G = "regex",
      V = "reactElement",
      B = "function",
      $ = "function" == typeof Symbol && Symbol.for,
      z = $ ? Symbol.for("react.memo") : 60115,
      J = $ ? Symbol.for("react.forward_ref") : 60112,
      K = "http://bit.ly/wdyr02",
      Q = (E(W = {}, F, "different objects."), E(W, q, "different objects that are equal by value."), E(W, U, "different date objects with the same value."), E(W, G, "different regular expressions with the same value."), E(W, V, "different React elements (remember that the <jsx/> syntax always produces a *NEW* immutable React element so a component that receives <jsx/> as props always re-renders.)."), E(W, B, "different functions with the same name."), W),
      X = !1;

  function Z(e) {
    var t = e.Component,
        r = e.displayName,
        n = e.hookName,
        o = e.prefixMessage,
        a = e.diffObjType,
        i = e.differences,
        s = e.values,
        c = e.options;
    i && i.length > 0 ? (c.consoleLog(E({}, r, t), "".concat(o, " of ").concat(a, " changes:")), i.forEach(function (e) {
      var t = e.pathString,
          r = e.diffType,
          o = e.prevValue,
          i = e.nextValue;
      c.consoleGroup("%c".concat("hook" === a ? "[hook ".concat(n, " result]") : "".concat(a, "."), "%c").concat(t, "%c"), "color:".concat(c.diffNameColor, ";"), "color:".concat(c.diffPathColor, ";"), "color:default;"), c.consoleLog("".concat(Q[r], " (more info at ").concat(n ? "http://bit.ly/wdyr3" : K, ")")), c.consoleLog(E({}, "prev ".concat(t), o), "!==", E({}, "next ".concat(t), i)), c.consoleGroupEnd();
    })) : i && (c.consoleLog(E({}, r, t), "".concat(o, " the ").concat(a, " object itself changed but its values are all equal."), "props" === a ? "This could have been avoided by making the component pure, or by preventing its father from re-rendering." : "This usually means this component called setState when no changes in its state actually occurred.", "More info at ".concat(K)), c.consoleLog("prev ".concat(a, ":"), s.prev, " !== ", s.next, ":next ".concat(a)));
  }

  function ee(e) {
    var t = e.Component,
        r = e.displayName,
        n = e.hookName,
        o = e.prevProps,
        a = e.prevState,
        i = e.prevHook,
        s = e.nextProps,
        c = e.nextState,
        u = e.nextHook,
        f = e.reason,
        l = e.options,
        p = e.ownerDataMap;

    if (function (e, t, r) {
      return !(X || !r.logOnDifferentValues && (!t.whyDidYouRender || !t.whyDidYouRender.logOnDifferentValues) && (e.propsDifferences && e.propsDifferences.some(function (e) {
        return e.diffType === F;
      }) || e.stateDifferences && e.stateDifferences.some(function (e) {
        return e.diffType === F;
      }) || e.hookDifferences && e.hookDifferences.some(function (e) {
        return e.diffType === F;
      })));
    }(f, t, l)) {
      l.consoleGroup("%c".concat(r), "color: ".concat(l.titleColor, ";"));
      var d = "Re-rendered because";

      if (f.propsDifferences && (Z({
        Component: t,
        displayName: r,
        prefixMessage: d,
        diffObjType: "props",
        differences: f.propsDifferences,
        values: {
          prev: o,
          next: s
        },
        options: l
      }), d = "And because"), f.stateDifferences && Z({
        Component: t,
        displayName: r,
        prefixMessage: d,
        diffObjType: "state",
        differences: f.stateDifferences,
        values: {
          prev: a,
          next: c
        },
        options: l
      }), f.hookDifferences && Z({
        Component: t,
        displayName: r,
        prefixMessage: d,
        diffObjType: "hook",
        differences: f.hookDifferences,
        values: {
          prev: i,
          next: u
        },
        hookName: n,
        options: l
      }), f.propsDifferences && f.ownerDifferences) {
        var h = p.get(o),
            y = p.get(s);
        l.consoleGroup("Rendered by ".concat(y.displayName));
        var m = "Re-rendered because";
        f.ownerDifferences.propsDifferences && (Z({
          Component: y.Component,
          displayName: y.displayName,
          prefixMessage: m,
          diffObjType: "props",
          differences: f.ownerDifferences.propsDifferences,
          values: {
            prev: h.props,
            next: y.props
          },
          options: l
        }), m = "And because"), f.ownerDifferences.stateDifferences && Z({
          Component: y.Component,
          displayName: y.displayName,
          prefixMessage: m,
          diffObjType: "state",
          differences: f.ownerDifferences.stateDifferences,
          values: {
            prev: h.state,
            next: y.state
          },
          options: l
        }), f.ownerDifferences.hookDifferences && f.ownerDifferences.hookDifferences.forEach(function (e, t) {
          var r = e.hookName,
              n = e.differences;
          return Z({
            Component: y.Component,
            displayName: y.displayName,
            prefixMessage: m,
            diffObjType: "hook",
            differences: n,
            values: {
              prev: h.hooks[t].result,
              next: y.hooks[t].result
            },
            hookName: r,
            options: l
          });
        }), l.consoleGroupEnd();
      }

      f.propsDifferences || f.stateDifferences || f.hookDifferences || l.consoleLog(E({}, r, t), "Re-rendered although props and state objects are the same.", "This usually means there was a call to this.forceUpdate() inside the component.", "more info at ".concat(K)), l.consoleGroupEnd();
    }
  }

  function te(e) {
    return e && "undefined" != typeof module && module.hot && module.hot.addStatusHandler && module.hot.addStatusHandler(function (t) {
      "idle" === t && (X = !0, setTimeout(function () {
        X = !1;
      }, e));
    }), ee;
  }

  var re = function re() {};

  function ne(e) {
    return e.displayName || e.name || e.type && ne(e.type) || e.render && ne(e.render) || (h.default(e) ? e : void 0);
  }

  var oe = "undefined" != typeof Element,
      ae = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103,
      ie = function ie(e) {
    return e.$$typeof === ae;
  };

  function se(e, t, r, n, o) {
    return r.push({
      diffType: o,
      pathString: n,
      prevValue: e,
      nextValue: t
    }), o !== F;
  }

  function ce(e, t, r) {
    var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "";
    if (e === t) return !0;
    if (!e || !t) return se(e, t, r, n, F);

    if (_.default(e) && _.default(t)) {
      var o = e.length;
      if (o !== t.length) return se(A(e), A(t), r, n, F);

      for (var a = [], i = 0, s = o; s--; s > 0) {
        var c = ce(e[s], t[s], a, "".concat(n, "[").concat(s, "]"));
        c && i++;
      }

      return i === o ? se(A(e), A(t), r, n, q) : (r.push.apply(r, a), se(A(e), A(t), r, n, F));
    }

    if (g.default(e) && g.default(t)) {
      if (e.size !== t.size) return se(new Set(e), new Set(t), r, n, F);
      var u,
          f = M(e);

      try {
        for (f.s(); !(u = f.n()).done;) {
          var l = u.value;
          if (!t.has(l)) return se(new Set(e), new Set(t), r, n, F);
        }
      } catch (e) {
        f.e(e);
      } finally {
        f.f();
      }

      return se(new Set(e), new Set(t), r, n, q);
    }

    if (w.default(e) && w.default(t)) return e.getTime() === t.getTime() ? se(new Date(e), new Date(t), r, n, U) : se(new Date(e), new Date(t), r, n, F);
    if (D.default(e) && D.default(t)) return e.toString() === t.toString() ? se(e, t, r, n, G) : se(e, t, r, n, F);
    if (oe && e instanceof Element && t instanceof Element) return se(e, t, r, n, F);

    if (ie(e) && ie(t)) {
      if (e.type !== t.type) return se(e, t, r, n, F);
      var p = ce(e.props, t.props, [], "".concat(n, ".props"));
      return se(e, t, r, n, p ? V : F);
    }

    if (b.default(e) && b.default(t)) return e.name === t.name ? se(e, t, r, n, B) : se(e, t, r, n, F);

    if (O.default(e) && O.default(t)) {
      var d = v.default(e),
          h = d.length;
      if (h !== v.default(t).length) return se(N({}, e), N({}, t), r, n, F);

      for (var y = h; y--; y > 0) {
        if (!m.default(t, d[y])) return se(N({}, e), N({}, t), r, n, F);
      }

      for (var R = [], k = 0, E = h; E--; E > 0) {
        var S = d[E],
            j = ce(e[S], t[S], R, "".concat(n, ".").concat(S));
        j && k++;
      }

      return k === h ? se(N({}, e), N({}, t), r, n, q) : (r.push.apply(r, R), se(N({}, e), N({}, t), r, n, F));
    }

    return se(e, t, r, n, F);
  }

  function ue(e, t, r) {
    try {
      var n = [];
      return ce(e, t, n, r), n;
    } catch (e) {
      if (e.message && e.message.match(/stack|recursion/i) || -2146828260 === e.number) return console.warn("Warning: why-did-you-render couldn't handle circular references in props.", e.name, e.message), !1;
      throw e;
    }
  }

  var fe = {};

  function le(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        n = r.shallow,
        o = void 0 === n || n;
    if (e === t) return !1;
    if (!o) return ue(e, t);
    var a = e || fe,
        i = t || fe,
        s = Object.keys(N(N({}, a), i));
    return y.default(s, function (e, t) {
      var r = ue(a[t], i[t], t);
      return r && (e = [].concat(A(e), A(r))), e;
    }, []);
  }

  function pe(e) {
    var t = e.prevOwnerData,
        r = e.nextOwnerData;
    if (!t || !r) return !1;
    var n = (t.hooks.length === 2 * r.hooks.length ? t.hooks.slice(t.hooks.length / 2) : t.hooks).map(function (e, t) {
      return {
        hookName: e.hookName,
        differences: le(e.result, r.hooks[t].result, {
          shallow: !1
        })
      };
    });
    return {
      propsDifferences: le(t.props, r.props),
      stateDifferences: le(t.state, r.state),
      hookDifferences: n.length > 0 && n
    };
  }

  function de(e, t, r, n, o, a, i) {
    var s = i.get(e),
        c = i.get(n);
    return {
      propsDifferences: le(e, n),
      stateDifferences: le(t, o),
      hookDifferences: le(r, a, {
        shallow: !1
      }),
      ownerDifferences: pe({
        prevOwnerData: s,
        nextOwnerData: c
      })
    };
  }

  function he(e) {
    var t = e.Component,
        r = e.displayName,
        n = e.hookName,
        o = e.prevProps,
        a = e.prevState,
        i = e.prevHook,
        s = e.nextProps,
        c = e.nextState,
        u = e.nextHook,
        f = e.options,
        l = e.ownerDataMap;
    return {
      Component: t,
      displayName: r,
      hookName: n,
      prevProps: o,
      prevState: a,
      prevHook: i,
      nextProps: s,
      nextState: c,
      nextHook: u,
      options: f,
      ownerDataMap: l,
      reason: de(o, a, i, s, c, u, l)
    };
  }

  function ye(e) {
    return e.prototype && !!e.prototype.isReactComponent;
  }

  function me(e) {
    return e.$$typeof === z;
  }

  function ve(e) {
    return e.$$typeof === J;
  }

  function ge(e) {
    var t = e.Component,
        r = e.displayName,
        n = e.options,
        o = e.React,
        a = e.isHookChange;
    return !function (e, t) {
      return t.exclude && t.exclude.length > 0 && t.exclude.some(function (t) {
        return t.test(e);
      });
    }(r, n) && !1 !== t.whyDidYouRender && (!a || !t.whyDidYouRender || !1 !== t.whyDidYouRender.trackHooks) && !!(t.whyDidYouRender || n.trackAllPureComponents && (t && t.prototype instanceof o.PureComponent || me(t)) || function (e, t) {
      return t.include && t.include.length > 0 && t.include.some(function (t) {
        return t.test(e);
      });
    }(r, n));
  }

  function be(e, t, r, n, o) {
    var a = function (r) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && x(e, t);
      }(u, r);
      var a,
          i,
          s,
          c = P(u);

      function u(t, r) {
        var n, o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, u), (o = c.call(this, t, r))._WDYR = {
          renderNumber: 0
        };
        var a = Y((n = C(o), j(u.prototype)), "render", n) || o.render;
        return a !== e.prototype.render && (o.render = function () {
          return u.prototype.render.apply(C(o)), a();
        }), o;
      }

      return a = u, (i = [{
        key: "render",
        value: function value() {
          if (this._WDYR.renderNumber++, "isStrictMode" in this._WDYR || (this._WDYR.isStrictMode = function (e) {
            for (var t = e && e._reactInternalFiber; t;) {
              if (1 & t.mode) return !0;
              t = t.return;
            }

            return !1;
          }(this)), !this._WDYR.isStrictMode || this._WDYR.renderNumber % 2 != 1) {
            if (this._WDYR.prevProps) {
              var r = he({
                Component: e,
                displayName: t,
                prevProps: this._WDYR.prevProps,
                prevState: this._WDYR.prevState,
                nextProps: this.props,
                nextState: this.state,
                options: n,
                ownerDataMap: o
              });
              n.notifier(r);
            }

            this._WDYR.prevProps = this.props, this._WDYR.prevState = this.state;
          }

          return Y(j(u.prototype), "render", this) ? Y(j(u.prototype), "render", this).call(this) : null;
        }
      }]) && k(a.prototype, i), s && k(a, s), u;
    }(e);

    try {
      a.displayName = t;
    } catch (e) {}

    return R.default(a, e), a;
  }

  function De(e, t, r, n, o, a) {
    var i = "string" == typeof e ? function (e, t) {
      return function (r) {
        return t.createElement(e, r);
      };
    }(e, n) : e;

    function s() {
      var e = arguments[0],
          s = n.useRef(),
          c = s.current;

      if (s.current = e, c) {
        var u = he({
          Component: i,
          displayName: r,
          prevProps: c,
          nextProps: e,
          options: o,
          ownerDataMap: a
        }),
            f = !u.reason.propsDifferences || t && 0 === u.reason.propsDifferences.length;
        f || o.notifier(u);
      }

      return i.apply(void 0, arguments);
    }

    try {
      s.displayName = r;
    } catch (e) {}

    return s.ComponentForHooksTracking = i, R.default(s, i), s;
  }

  function we(e, t, r, n, o) {
    var a = e.type,
        i = ye(a),
        s = ve(a),
        c = me(a),
        u = s ? a.render : a,
        f = i ? be(u, t, 0, n, o) : c ? we(u, t, r, n, o) : De(u, !0, t, r, n, o);

    try {
      f.displayName = ne(u);
    } catch (e) {}

    f.ComponentForHooksTracking = e, R.default(f, u);
    var l = r.memo(s ? r.forwardRef(f) : f, e.compare);

    try {
      l.displayName = t;
    } catch (e) {}

    return R.default(l, e), l;
  }

  var Oe = Symbol("initial-hook-value");

  function _e(e, t, r, n, o, a, i) {
    var s = t.path,
        c = s ? d.default(r, s) : r,
        u = n.useRef(1);
    null != i.current[0] && u.current !== i.current[0].renderNumber && (i.current = []), i.current.push({
      hookName: e,
      result: c,
      renderNumber: u.current
    }), u.current++;
    var f = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner.current,
        l = n.useRef(Oe);
    if (!f) return r;
    var p = f.type.ComponentForHooksTracking || f.type,
        h = ne(p);
    if (!ge({
      Component: p,
      displayName: h,
      options: o,
      React: n,
      isHookChange: !0
    })) return r;
    var y = l.current;

    if (l.current = r, y !== Oe) {
      var m = he({
        Component: p,
        displayName: h,
        hookName: e,
        prevHook: s ? d.default(y, s) : y,
        nextHook: c,
        options: o,
        ownerDataMap: a
      });
      m.reason.hookDifferences && o.notifier(m);
    }

    return r;
  }

  function Re(e, t, r, n, o, a) {
    return me(t) ? we(t, r, n, o, a) : ve(t) ? function (e, t, r, n, o) {
      var a = e.render,
          i = me(a),
          s = i ? a.type : a,
          c = De(s, i, t, r, n, o);
      c.displayName = ne(s), c.ComponentForHooksTracking = s, R.default(c, s);
      var u = r.forwardRef(i ? r.memo(c, a.compare) : c);

      try {
        u.displayName = t;
      } catch (e) {}

      return R.default(u, e), u;
    }(t, r, n, o, a) : ye(t) ? be(t, r, 0, o, a) : De(t, !1, r, n, o, a);
  }

  function ke(e, t, r, n, o, a) {
    if (e.has(t)) return e.get(t);
    var i = Re(0, t, r, n, o, a);
    return e.set(t, i), i;
  }

  function Ee(e) {
    return !!e && (me(e) ? Ee(e.type) : ve(e) ? Ee(e.render) : "function" == typeof e || void 0);
  }

  var Se = {
    useState: {
      path: "0"
    },
    useReducer: {
      path: "0"
    },
    useContext: !0,
    useMemo: !0
  };

  function Ne(e, t) {
    var r = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = console.group,
          r = console.groupEnd;
      return e.collapseGroups ? t = console.groupCollapsed : e.onlyLogs && (t = console.log, r = re), N({
        include: null,
        exclude: null,
        notifier: e.notifier || te("hotReloadBufferMs" in e ? e.hotReloadBufferMs : 500),
        onlyLogs: !1,
        consoleLog: console.log,
        consoleGroup: t,
        consoleGroupEnd: r,
        logOnDifferentValues: !1,
        logOwnerReasons: !1,
        trackHooks: !0,
        titleColor: "#058",
        diffNameColor: "blue",
        diffPathColor: "red",
        trackExtraHooks: [],
        trackAllPureComponents: !1
      }, e);
    }(t),
        n = e.createElement,
        o = e.createFactory,
        a = e.cloneElement,
        i = new WeakMap(),
        s = new WeakMap(),
        c = {
      current: []
    };

    function u(t) {
      var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner.current;

      if (r) {
        var n = r.type.ComponentForHooksTracking || r.type,
            o = ne(n);
        s.set(t.props, {
          Component: n,
          displayName: o,
          props: r.pendingProps,
          state: null != r.stateNode ? r.stateNode.state : null,
          hooks: c.current
        });
      }
    }

    var f = null;

    if (e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && Object.defineProperty(e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, "current", {
      get: function get() {
        return f;
      },
      set: function set(e) {
        f = e, c.current = [];
      }
    }), e.createElement = function (t) {
      for (var o = null, a = null, c = null, f = arguments.length, l = new Array(f > 1 ? f - 1 : 0), p = 1; p < f; p++) {
        l[p - 1] = arguments[p];
      }

      try {
        if (o = Ee(t) && ge({
          Component: t,
          displayName: ne(t),
          React: e,
          options: r
        })) {
          a = t && t.whyDidYouRender && t.whyDidYouRender.customName || ne(t), c = ke(i, t, a, e, r, s);
          var d = n.apply(e, [c].concat(l));
          return r.logOwnerReasons && u(d), d;
        }
      } catch (e) {
        r.consoleLog("whyDidYouRender error. Please file a bug at https://github.com/welldone-software/why-did-you-render/issues.", {
          errorInfo: {
            error: e,
            componentNameOrComponent: t,
            rest: l,
            options: r,
            isShouldTrack: o,
            displayName: a,
            WDYRPatchedComponent: c
          }
        });
      }

      return n.apply(e, [t].concat(l));
    }, Object.assign(e.createElement, n), e.createFactory = function (t) {
      var r = e.createElement.bind(null, t);
      return r.type = t, r;
    }, Object.assign(e.createFactory, o), e.cloneElement = function () {
      for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }

      var i = a.apply(e, n);
      return r.logOwnerReasons && u(i), i;
    }, Object.assign(e.cloneElement, a), r.trackHooks) {
      var l = Object.entries(Se).map(function (t) {
        var r = H(t, 2),
            n = r[0],
            o = r[1];
        return [e, n, o];
      });
      [].concat(A(l), A(r.trackExtraHooks)).forEach(function (t) {
        var n = H(t, 3),
            o = n[0],
            a = n[1],
            i = n[2],
            u = void 0 === i ? {} : i,
            f = o[a],
            l = a[0].toUpperCase() + a.slice(1),
            p = function p() {
          for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
            n[o] = arguments[o];
          }

          var i = f.call.apply(f, [this].concat(n));
          return _e(a, u, i, e, r, s, c), i;
        };

        Object.defineProperty(p, "name", {
          value: l,
          writable: !1
        }), Object.assign(p, {
          originalHook: f
        }), o[a] = p;
      });
    }

    return e.__REVERT_WHY_DID_YOU_RENDER__ = function () {
      Object.assign(e, {
        createElement: n,
        createFactory: o,
        cloneElement: a
      }), i = null, [].concat(A(Object.keys(Se).map(function (t) {
        return [e, t];
      })), A(r.trackExtraHooks)).forEach(function (e) {
        var t = H(e, 2),
            r = t[0],
            n = t[1];
        r[n].originalHook && (r[n] = r[n].originalHook);
      }), delete e.__REVERT_WHY_DID_YOU_RENDER__;
    }, e;
  }

  return Ne.defaultNotifier = ee, Ne;
});